import styled from 'styled-components';

export const Container = styled.div`
  .item-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .content-item {
    width: 100%;
    padding-left: 16px;
    padding-top: 8px;
    border-radius: 4px;
    line-height: 1px;
  }
  .auto-complete-item {
    flex-wrap: wrap;
    position: relative;
  }
  .check-boxes {
    display: flex;
    flex-direction: column;
    padding-top: 5px;
  }
`;
